const constantes = {
    // GUIA 
    consultarGuia: "/v1/guias/consultarGuia",
    visualizarGuia:"/v1/guias/visualizarGuia",
    detalharCredito:"/v1/guias/detalharCredito",    
    ///
    limiteLancamentos: 3000, // Limite máximo

    tiposDeIdentificadores: "/v1/guias/buscarTiposDeIdentificadores",
    consultarFaixaFacAR: "/v1/guias/consultarFaixaFacAR",
    processarNovaFaixaFacAR: "/v1/guias/processarNovaFaixaFacAR",
    arquivoTXT: "/v1/guias/arquivoTXT",

    quantidadeDeLancamentos: "/v1/guias/quantidadeDeLancamentos",
    buscarCodLancamento: "/v1/guias/buscarCodLancamento",
    buscarEndereco: "/v1/guias/buscarEndereco",
    validarIndiceCadastralParaCPF: "/v1/guias/validarIndiceCadastralParaCPF",
    atualizarLogadoGovBr: "/v1/guias/atualizarLogadoGovBr",
    buscarEnderecoComBairro: "/v1/guias/buscarEnderecoComBairro",
    buscarIdPessoaPorCodigoNacional: "/v1/guias/buscarIdPessoaPorCodigoNacional",
    pesquisarDram: "/v1/guias/pesquisarDram",
    retornaIndicesCadastraisPorEndereco: "/v1/guias/retornaIndicesCadastraisPorEndereco",
    buscarContribuinte: "/v1/guias/buscarContribuinte",
    verificaLancamento: "/v1/guias/verificaLancamento",
    possuiPermissaoEspecial: "/v1/guias/possuiPermissaoEspecial",
    retornaUltimaDataUtilMes: "/v1/guias/retornaUltimaDataUtilMes",
    verificaIRestricaoTributoUsuarioNaoLogado: "/v1/guias/verificaIRestricaoTributoUsuarioNaoLogado",
    buscaImoveisIndice: "/v1/guias/buscaImoveisIndice",
    buscaImoveisIndiceSemRecaptcha: "/v1/guias/buscaImoveisIndiceSemRecaptcha",
    buscaListaLoteCTMPorIndiceCadastral: "/v1/guias/buscaListaLoteCTMPorIndiceCadastral",
    buscaEnderecoPorCepNumero: "/v1/guias/buscaEnderecoPorCepNumero",
    gravaEndereco: "/v1/guias/gravaEndereco",
    gravaNovoEnderecoImovel: "/v1/guias/gravaNovoEnderecoImovel",
    buscaTiposComplemento: "/v1/guias/buscaTiposComplemento",
    agrupaLancamentos: "/v1/guias/agrupaLancamentos",
    agrupaLancamentosIptuLogadoGov: "/v1/guias/agrupaLancamentosIptuLogadoGov",
    agrupaPerguntas: "/v1/guias/agrupaPerguntas",  
    agrupaLancamentosIptu: "/v1/guias/agrupaLancamentosIptu",
    imprimeSimulacao: "/v1/guias/imprimeSimulacao",
    imprimeTermoEmissaoGuia: "/v1/guias/imprimeTermoEmissaoGuia",
    retornaCalculos: "/v1/guias/retornaCalculos", 
    retornaCalculosParcelar: "/v1/guias/retornaCalculosParcelar", 
    recuperaEnderecoCep: "/v1/guias/recuperaEnderecoCep",
    retornaGuiaAVista: "/v1/guias/retornaGuiaAVista",
    retornaGuiaParcelamentos: "/v1/guias/retornaGuiaParcelamentos",
    retornaRelatorioDram: "/v1/guias/retornaRelatorioDram",
    retornaGuiaDramITBI: "/v1/guias/retornaGuiaDramITBI",
    confirmarEmissaoGuia: "/v1/guias/confirmarEmissaoGuia",
    retornaDetalheLancamento: "/v1/guias/retornaDetalheLancamento",
    geraRelacaoLancamento: "/v1/guias/geraRelacaoLancamento",
    enviarEmailEmissaoGuiaParcelamento: "/v1/guias/enviarEmailEmissaoGuiaParcelamento",
    buscarCodigoConfirmacao: "/v1/guias/buscarCodigoConfirmacao",
    enviarSMSEmissaoGuiaParcelamento: "/v1/guias/enviarSMSEmissaoGuiaParcelamento",
    retornaGuiaParcelamento: "/v1/guias/retornaGuiaParcelamento",
    retornaOpcoesParcto: "/v1/guias/retornaOpcoesParcto",   
    
    buscarPessoaPeloCPFCNPJ: "/v1/guias/buscarPessoaPeloCPFCNPJ",
    cadastraEmailTelefone: "/v1/guias/cadastraEmailTelefone",
    enviarEmailCodigoCadastroEmail: "/v1/guias/enviarEmailCodigoCadastroEmail",
    buscarCNPJRelacionados: "/v1/guias/buscarCNPJRelacionados",
    buscarGuiasRelacionadas: "/v1/guias/buscarGuiasRelacionadas",

    emiteGuiaParcelamentoTacito: "/v1/guias/emiteGuiaParcelamentoTacito",
    emiteDemonstrativoITBI: "/v1/guias/emiteDemonstrativoITBI",
    buscarPerguntasRespostas: "/v1/guias/buscarPerguntasRespostas",  
    cadastrarPerguntaResposta: "/v1/guias/cadastrarPerguntaResposta",  
    editarPerguntaResposta: "/v1/guias/editarPerguntaResposta",  
    inativarPerguntaResposta: "/v1/guias/inativarPerguntaResposta",  
    buscarIDtransacaoITBI: "/v1/guias/buscarIDtransacaoITBI",
    buscarIdProcesso: "/v1/guias/buscarIdProcesso",
    buscarFranqueadas: "/v1/guias/buscarFranqueadas",
    retornaPeriodoInterrupcaoAltEndIPTU: "/v1/guias/retornaPeriodoInterrupcaoAltEndIPTU",  
    casosPermissaoAcesso: "/v1/guias/casosPermissaoAcesso", 
    verficaParcelamentoInscritoDA: "/v1/guias/verficaParcelamentoInscritoDA", 

    retornaidInclusaoTributariaItbi: "/v1/guias/retornaidInclusaoTributariaItbi",
}

export default constantes
